// src/hooks/useBrightness.js
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setBrightnessValue } from "../services/slices/appConfig";

const STORAGE_KEY = "appBrightness";

export default function useBrightness() {
  const dispatch = useDispatch();

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    const initial = stored != null ? parseFloat(stored) : 1.0;

    // hydrate Redux once
    dispatch(setBrightnessValue(initial));

    // set CSS var once
    document.documentElement.style.setProperty("--app-brightness", initial);
  }, [dispatch]);
}
